import {
    Compiler,
    Component,
    Injector,
    OnDestroy,
    ReflectiveInjector,
    SystemJsNgModuleLoader
} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {
    APPLICATION_SCOPE_TYPES,
    ITCIAppCustomizationParam,
    ITCIApplication,
    ITCIApplicationDeployRequest,
    ITCIApplicationUpdateProvider,
    ITCIApplicationUpdateRequest,
    ITCIAssetTag,
    ITCIAssetTagsList,
    ITCITenantComponentOptions,
    QUERY_PARAMS,
    TCI_APP_CUSTOMIZATION_TYPE,
    TCI_APP_DETAIL_MENU_TYPE,
    TCI_APP_FEATURE_TYPE,
    TCI_ASSET_TAGS_COMPONENT_MODE,
    TCI_COMPONENT_MODE,
    TCI_TENANT_SERVICE_PROVIDER_TYPE,
    TCI_UPDATE_ACTION_TYPE,
    TCIMainMenu,
    TCIMainMenuSubroutes,
    TCITenantAppCategory,
    TCITenantAppDetailsMenu,
    TCITenantAppType,
    TCITenantSelectorType,
    USER_ROLES
} from "@tci/common";
import {NgCustomizationProviderService} from "../ng-shared/ng-services/ng-customization-provider.service";
import {NgTagsService} from "../ng-shared/ng-services/ng-tags.service";

import {AbstractTciTenantComponentLoader} from "../ng-tenant/tci-tenant-component-loader.component";
import {ITCIAppDetailsMenuOutput} from "../ng-tenant/tci-tenant-components";

import {NgAppListService} from "../ng-app-list/ng-app-list.service";
import {InlineMenuItemHandlerFunction, TCITenantLoaderComponent} from "../ng-tenant/tci-tenant-component";
import {TCITenantMenuServices} from "../ng-tenant/tci-tenant.menu";
import {TCITenantRemoteServices} from "../ng-tenant/tci-tenant-remote-services";
import {TciTenantService} from "../ng-tenant/tci-tenant.service";

import {BaseAppDetailMenuComponentInput} from "./ng-app-details-menu";
import {BaseAppDetailUserTimestampComponentInput} from "./ng-app-user-timestamp/base-app-user-timestamp.component";
import {BaseAppDetailLiveStatsComponentInput} from "./ng-app-live-stats/base-app-detail-live-stats.component";
import {NgUserService} from "../ng-shared/ng-services/ng-user.service";
import {NgAppFeatureToggleService} from "../ng-shared/ng-services/ng-app-feature-toggle.service";
import {ITCITenantCacheOptions, TciTenantComponentCacheService} from "../ng-tenant/tci-tenant-component-cache.service";
import {AbstractTciTenant, TciTenantModelService} from "../ng-tenant/tci-tenant.model";
import {NgToastrService} from "../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import {NgWaitService} from "../ng-shared/ng-components/ng-wait/ng-wait.service";
import {NgAppDeployService} from "../ng-app-deploy/ng-app-deploy.service";
import {NgAppChangeNotificationService} from "../ng-shared/ng-services/ng-app-change-notification.service";
import {NgAppHMService} from "../ng-app-hamburger-menu/ng-app-hamburger-menu.service";

import {Observable, Subscription} from "rxjs";
import * as lodash from "lodash";

// #region
export class BaseAppDetailComponentLoaderResolverInput extends BaseAppDetailMenuComponentInput {
    /**
     *
     * @param tenantAppType
     * @param componentSelector
     * @param application
     * @param userService
     * @param featureToggleService
     * @param mode
     * @param componentOption
     * @param leftSubMenuRouteId
     */
    constructor(
        public tenantAppType: TCITenantAppType,
        public componentSelector: TCITenantSelectorType,
        public application: ITCIApplication,
        public userService: NgUserService,
        public featureToggleService: NgAppFeatureToggleService,
        public mode: TCI_COMPONENT_MODE | string,
        public componentOption?: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>,
        public leftSubMenuRouteId?: string
    ) {
        super(tenantAppType, componentSelector, application, userService, featureToggleService,
            mode, componentOption, leftSubMenuRouteId);
    }
}

@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-tenant-dyn-cmp",
    template: "<template #dynamic></template>"
})
export class TCITenantDetailsDynLoaderComponent
    extends AbstractTciTenantComponentLoader<any, BaseAppDetailComponentLoaderResolverInput, any> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}

// #endregion

@Component({
    selector: "ng-app-details",
    templateUrl: "./ng-app-details.component.html",
    styleUrls: ["./ng-app-details.component.less"]
})
export class NgAppDetailsComponent implements OnDestroy {
    private appId: string;
    app: ITCIApplication;
    private routeId: string;
    private submenuLeftRouteId: string;
    private submenuLeftRouteIdCache: string;
    private subsCollection: Subscription[] = [];

    // Tags
    tagsMode: TCI_ASSET_TAGS_COMPONENT_MODE;

    tabs: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>[] = [];
    selectedTab: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>;
    tabBusy = false; // IPAS-12322
    tenantInput: BaseAppDetailMenuComponentInput;

    noTenant = false;

    categoryLabel = "";
    isRO = false; // For RO pill display
    private lastDeploymentState: string;

    // Inline pills
    private tenantInputMarketplace: BaseAppDetailMenuComponentInput;
    private tenantInputAppVersion: BaseAppDetailMenuComponentInput;
    private tenantInputMarkLive: BaseAppDetailMenuComponentInput;
    private tenantInputEndpointsToggle: BaseAppDetailMenuComponentInput;
    private tenantInputAutoScaleToggle: BaseAppDetailMenuComponentInput;

    // Live Status Component
    private tenantInputLiveStatus: BaseAppDetailLiveStatsComponentInput;
    private tenantInputUserTimestamp: BaseAppDetailUserTimestampComponentInput;

    // Status Hamburger Menu
    tabFixedRoute: string;
    showStatusMenu = false;
    statusMenuOptions: TCITenantAppDetailsMenu[] = [];
    statusMenuSelectedOption: TCITenantAppDetailsMenu;
    statusMenuCmpInput: BaseAppDetailMenuComponentInput;
    statusMenuOptionsInlineFns: {[key: string]: InlineMenuItemHandlerFunction<any, any, any>} = {};

    // Name + Description Update
    appUpdateIsBusy = false;
    appUpdateProvider: ITCIApplicationUpdateProvider;
    canUpdateName = false;
    originalAppName: string;
    appNameUpdateErrorMsg: string;
    isNameUpdating = false;

    canUpdateDescription = false;
    originalAppDescription: string;
    appDescriptionUpdateErrorMsg: string;
    appDescriptionPristine = true; // To avoid displaying the placeholder twice
    isDescriptionUpdating = false;

    // Custom Configs
    private CUSTOM_TYPES = TCI_APP_CUSTOMIZATION_TYPE;
    private customConfig: {[key: string]: ITCIAppCustomizationParam} = {};

    // Deploy confirmation dialogs
    deployConfirmIsAliveShow = false;
    deployConfirmIsAliveShowInput: ITCIApplicationDeployRequest;

    // Component Cache Options
    private comOpts: ITCITenantCacheOptions = {
        routeId: TCIMainMenu.MAIN_MENU_APPLICATIONS.getRouteId(),
        subRouteId: TCIMainMenuSubroutes.TCI_APPLICATION_APP_DETAILS.getSubRouteId()
    };

    // Asset tags
    private tagsIsDirty = false;
    private deltaSelectedTags: ITCIAssetTag[] = [];
    pristineSelectedTags: ITCIAssetTag[] = [];
    hasTagsList = false;
    tagsList: ITCIAssetTagsList;
    allAssetTags: ITCIAssetTag[] = [];
    selectedTags: ITCIAssetTag[] = [];
    tagsPillVisible = false;
    tagsUpdateIsBusy = false;
    private componentIsAlive = true; // To avoid unecessary actions after this component is destroyed

    constructor(
        private appsAPISrv: NgAppListService,
        private tenantMenuSrv: TCITenantMenuServices,
        private tenantModelSvc: TciTenantModelService,
        private tenantSvc: TciTenantService,
        private tenantRemoteServices: TCITenantRemoteServices,
        private cacheSvc: TciTenantComponentCacheService,
        private toastrSvc: NgToastrService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private userService: NgUserService,
        private featureToggleService: NgAppFeatureToggleService,
        private customizationProviderService: NgCustomizationProviderService,
        private appDeplSvc: NgAppDeployService,
        private appRefreshNotifSvc: NgAppChangeNotificationService,
        private blockUiService: NgWaitService,
        private tagsService: NgTagsService,
        private hmSvc: NgAppHMService,
        private injector: Injector
    ) {
        Observable
            .combineLatest(this.route.params, this.route.queryParams, (params, qparams) => ({params, qparams}))
            .subscribe(routeData => {
                this.appId = routeData.params["inputid"];
                this.routeId = routeData.params["routeid"];

                this.submenuLeftRouteIdCache = this.submenuLeftRouteId; // To restore the route
                this.submenuLeftRouteId = routeData.params["submenuleft"];

                const appTypeParam: string = routeData.qparams[QUERY_PARAMS.APP_TYPE];

                if (!this.appId || !this.routeId || !appTypeParam) {
                    console.error("Not enough route data to get the application information");
                    this.router.navigate(["/applications"]);
                    return;
                }

                if (!this.app) {
                    this.blockUiService.block(); // Initialize blocker
                    this.appsAPISrv
                        .getAppById(this.appId, TCITenantAppType.fromString(appTypeParam))
                        .catch(e => { // IPAS-12295
                            const msg = `Failed to open App Details page. The app was deleted by another user and no longer exists.`;
                            this.toastrSvc.error(msg);
                            console.error(msg, this.appId, e);
                            this.goBack();
                            return Observable.of(null);
                        })
                        .filter(data => !!data) // IPAS-16031
                        .flatMap(data => {
                            this.app = data;
                            this.comOpts.tenantType = this.app.type;
                            this.categoryLabel = TCITenantAppCategory.fromApplication(this.app).label;
                            this.originalAppName = data.name;
                            this.originalAppDescription = data.description && data.description.length > 0 ? data.description : "App description goes here";
                            return this.cacheSvc
                                .getCache(false, this.comOpts)
                                .flatMap(() => {
                                    this.setTagsMode();
                                    this.initTags();

                                    // IPAS-16123 - Scribe won't ever display the RO pill
                                    if (!this.app.type.equals(TCITenantAppType.scribe)) {
                                        if (this.app.onPremise && !this.app.remoteManagement) { // IPAS-16161 - OnPremise apps are read only
                                            this.isRO = true;
                                        } else {
                                            this.hmSvc.checkIsRO(this.app)
                                                .subscribe(isRO => this.isRO = isRO);
                                        }
                                    }

                                    const menuInput = new BaseAppDetailMenuComponentInput(
                                        data.type,
                                        null,
                                        data,
                                        this.userService,
                                        this.featureToggleService,
                                        TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL,
                                        undefined, this.submenuLeftRouteId);
                                    return this.tenantMenuSrv
                                        .getAppDetailMenuItems(data.type, TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU, menuInput);
                                });
                        })
                        .subscribe(
                            res => {
                                this.blockUiService.unblock(); // Hide blocker

                                if (res && res.length > 0) {
                                    this.tabs = res;
                                    this.mountTabComponent()
                                        .identifyTenantProvider();

                                    // For HM
                                    this.subsCollection.push(
                                        this.hmSvc.getAppMenuOptionsSubject(this.app) // Listen for HM changes
                                            .subscribe(opts => {
                                                this.setStatusMenuOptions(opts);
                                                this.mountHeaderComponents();
                                            }),

                                        this.hmSvc.getAppMenuOptions(this.app, TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HAMBURGER_MENU)
                                            .subscribe() // Initialize HM options
                                    );

                                    if (this.routeId === QUERY_PARAMS.DEFAULT_ROUTE) { // Nav to main tab if route is "default" constant
                                        this.navigateComponents(lodash.first(this.tabs).getRouteId(), true);
                                    }
                                } else {
                                    this.noTenant = true;
                                    console.warn("There're no details components defined for this application type");
                                }
                            },
                            err => console.error(err)
                        );
                } else { // Tab/Modal invoked
                    this.mountTabComponent();
                    this.mountStatusMenuComponent();
                    this.tabBusy = false;
                }
            });

        // FE Custom Config Setup
        this.getCustomConfig();

        this.subsCollection.push(
            this.appDeplSvc.getDialogRequestSubj()
                .filter(req => req.appId === this.appId)
                .subscribe(req => {
                    this.deployConfirmIsAliveShowInput = req;
                    this.deployConfirmIsAliveShow = true;
                })
        );
    }

    ngOnDestroy() {
        this.componentIsAlive = false;
        this.saveSelectedTags();
        this.subsCollection.forEach(s => !s.closed && s.unsubscribe());

        if (this.app && this.app.id) { // IPAS-16031
            this.appRefreshNotifSvc.unsetAuditsData(this.app);
            this.hmSvc.removeHMSubject(this.app);
        }
    }

    getInitialTab(): string {
        const initialTab = this.tabs.find(_tab => _tab.getRouteId() === this.routeId);
        return initialTab ? initialTab.getRouteId() : lodash.first(this.tabs).getRouteId();
    }

    mountTabComponent() {
        /**
         * "routeid" could be from tab or hamMenu
         * The param could come from init or from event
         * In either case a tab should ALWAYS be present
         */
        const tabRoutes = TCITenantAppDetailsMenu.getAllMenuItems(TCI_APP_DETAIL_MENU_TYPE.MAIN_MENU).map(m => m.getRouteId());
        let tabId: string;

        if (tabRoutes.includes(this.routeId)) { // "routeid" param is a tab
            tabId = this.routeId;
        } else if (tabRoutes.includes(this.tabFixedRoute)) { // hamMenu is opened and a fixed tab is cached
            tabId = this.tabFixedRoute;
        } else { // No initial tab. The user could have pasted an URL with hamMenu "routeid"
            tabId = this.getInitialTab();
        }

        if (this.selectedTab && (this.selectedTab.getRouteId() === tabId || this.tabFixedRoute === tabId)) { // Same tab, different submenu?
            this.tenantInput.leftSubMenuRouteId = this.submenuLeftRouteId; // Update the submenu information
            return this;
        }

        const tab = this.tabs.filter(_tab => _tab.getRouteId() === tabId).pop();
        this.tenantInput = new BaseAppDetailMenuComponentInput(
            this.app.type,
            tab.getComponentSelectorType(),
            this.app,
            this.userService,
            this.featureToggleService,
            TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL,
            tab,
            this.submenuLeftRouteId);
        this.tabFixedRoute = tabId; // Store the route of the mounted tab
        this.selectedTab = tab;

        return this;
    }

    goBack() {
        this.router.navigate(["applications"]);
    }

    navigateComponents(routeId: string, replaceUrl = false) {
        const path: any[] = ["applications", "details", routeId, this.appId];
        if (this.submenuLeftRouteIdCache) { // Restore the auxiliar param if it exist
            path.push({submenuleft: this.submenuLeftRouteIdCache});
        }
        this.router.navigate(path, {preserveQueryParams: true, preserveFragment: true, replaceUrl});
    }

    /**
     * <Live Status Component>
     */
    mountHeaderComponents() {
        // Define objects to be used at preload check
        const preloadMap = this.tenantMenuSrv.getTenantPreloadMap(this.app.type);
        const tenantService = this.tenantModelSvc.getTenants()[this.app.type.toString()] as AbstractTciTenant;
        const resolvedProviders = ReflectiveInjector.resolve([
            {provide: Injector, useValue: this.injector},
            {provide: TciTenantModelService, useValue: this.tenantModelSvc}
        ]);
        const serviceInjector = ReflectiveInjector.fromResolvedProviders(resolvedProviders, tenantService.getInjector()) || this.injector;
        const updateHeaderCompAvailablePreload = (
            input: BaseAppDetailMenuComponentInput,
            cbTrue: Function, // To be called if the response is truthy
            cbFalse: Function // To be called if the response is falsy
        ) => {
            let canLoadObs = Observable.of(false);
            const type = input.componentSelector.toString();
            if (preloadMap && preloadMap[type]) {
                const preloadFn = preloadMap[type].canLoadComponentFn;
                const canLoad = preloadFn(null, input, serviceInjector);
                if (typeof canLoad === "boolean") {
                    canLoadObs = Observable.of(canLoad);
                } else if ((canLoad as Observable<boolean>).subscribe) {
                    canLoadObs = canLoad;
                }
            }

            canLoadObs
                .map(rs => !!rs)
                .subscribe((rs: boolean) => {
                    if (rs) {
                        cbTrue();

                        if (input.componentOption && this.routeId === input.componentOption.getRouteId()) { // Open HM modal if needed
                            this.mountStatusMenuComponent();
                        }
                    } else {
                        cbFalse();
                    }
                });
        };

        // Catalog all HM options to use at Inputs
        const options = TCITenantAppDetailsMenu.getAllMenuItems();

        // Check for Marketplace component
        const marketplaceType = TCITenantSelectorType.TCI_APP_DETAIL_CREATE_LISTING;
        const marketplaceOption = options.find(opt => opt.getComponentSelectorType().isEqualTo(marketplaceType.toString()));
        const marketplaceInput = new BaseAppDetailMenuComponentInput(this.app.type, marketplaceType,
            this.app, this.userService, this.featureToggleService, TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HEADER, marketplaceOption, null);

        updateHeaderCompAvailablePreload(
            marketplaceInput,
            () => lodash.isUndefined(this.tenantInputMarketplace) ? this.tenantInputMarketplace = marketplaceInput : void (0),
            () => delete this.tenantInputMarketplace
        );

        // Check for App Version component
        const appVersionType = TCITenantSelectorType.TCI_APP_DETAIL_APP_VERSION;
        const appVersionOption = options.find(opt => opt.getComponentSelectorType().isEqualTo(appVersionType.toString()));
        const appVersionInput = new BaseAppDetailMenuComponentInput(this.app.type, appVersionType,
            this.app, this.userService, this.featureToggleService, TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HEADER, appVersionOption, null);

        updateHeaderCompAvailablePreload(
            appVersionInput,
            () => lodash.isUndefined(this.tenantInputAppVersion) ? this.tenantInputAppVersion = appVersionInput : void (0),
            () => delete this.tenantInputAppVersion
        );

        // Check for Mark Alive component
        const markLiveType = TCITenantSelectorType.TCI_APP_DETAIL_MARK_LIVE;
        const markLiveOption = options.find(opt => opt.getComponentSelectorType().isEqualTo(markLiveType.toString()));
        const markLiveInput = new BaseAppDetailMenuComponentInput(this.app.type, markLiveType,
            this.app, this.userService, this.featureToggleService, TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HEADER, markLiveOption, null);

        updateHeaderCompAvailablePreload(
            markLiveInput,
            () => lodash.isUndefined(this.tenantInputMarkLive) ? this.tenantInputMarkLive = markLiveInput : void (0),
            () => delete this.tenantInputMarkLive
        );

        // Check for Endpoints Toggle component
        const endpointsType = TCITenantSelectorType.TCI_APP_DETAIL_SET_ENDPOINT;
        const endpointsOption = options.find(opt => opt.getComponentSelectorType().isEqualTo(endpointsType.toString()));
        const endpointsToggleInput = new BaseAppDetailMenuComponentInput(this.app.type, endpointsType,
            this.app, this.userService, this.featureToggleService, TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HEADER, endpointsOption, null);

        updateHeaderCompAvailablePreload(
            endpointsToggleInput,
            () => lodash.isUndefined(this.tenantInputEndpointsToggle) ? this.tenantInputEndpointsToggle = endpointsToggleInput : void (0),
            () => delete this.tenantInputEndpointsToggle
        );

        // Check for LiveStatus
        const liveStatusType = TCITenantSelectorType.TCI_APP_DETAIL_PANEL_LIVE_STATS;
        const liveStatusOption = options.find(opt => opt.getComponentSelectorType().isEqualTo(liveStatusType.toString()));
        const liveStatusInput = new BaseAppDetailLiveStatsComponentInput(this.app.type, liveStatusType, this.app, this.userService,
            this.featureToggleService, null, liveStatusOption);

        updateHeaderCompAvailablePreload(
            liveStatusInput,
            () => lodash.isUndefined(this.tenantInputLiveStatus) ? this.tenantInputLiveStatus = liveStatusInput : void (0),
            () => delete this.tenantInputLiveStatus
        );

        // Check timestamp
        const timestampType = TCITenantSelectorType.TCI_APP_DETAIL_USER_TIMESTAMP;
        const timestampOption = options.find(opt => opt.getComponentSelectorType().isEqualTo(timestampType.toString()));
        const timestampInput = new BaseAppDetailUserTimestampComponentInput(this.app.type, timestampType,
            this.app, this.userService, this.featureToggleService, this.customizationProviderService, null, timestampOption);

        updateHeaderCompAvailablePreload(
            timestampInput,
            () => lodash.isUndefined(this.tenantInputUserTimestamp) ? this.tenantInputUserTimestamp = timestampInput : void (0),
            () => delete this.tenantInputUserTimestamp
        );

        // Check for AutoScale Toggle component (That component is not from hamburger menu)
        this.featureToggleService.getAppFeatures()
            .filter(res => res[TCI_APP_FEATURE_TYPE.APP_AUTO_SCALE].enabled)
            .subscribe(() =>
                this.tenantInputAutoScaleToggle = new BaseAppDetailMenuComponentInput(
                    this.app.type,
                    TCITenantSelectorType.TCI_APP_DETAIL_ENV_AUTO_SCALE,
                    this.app,
                    this.userService,
                    this.featureToggleService,
                    TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HEADER,
                    undefined,
                    null)
            );

        return this;
    }
    /**
     * </Live Status Component>
     *
     * <Hamburger Menu Status>
     */
    private setStatusMenuOptions(opts: TCITenantAppDetailsMenu[]) {
        this.statusMenuOptions = opts;

        // Feed the inline HM items collection
        const preloadMap = this.tenantMenuSrv.getTenantPreloadMap(this.app.type);
        this.statusMenuOptions
            .forEach(opt => {
                const selStr = opt.getComponentSelectorType().toString();

                // Identify inline components
                this.statusMenuOptionsInlineFns[selStr] = preloadMap[selStr] && preloadMap[selStr].inlineMenuHandlerFn;
            });
    }

    toggleStatusMenu($event: MouseEvent) {
        this.showStatusMenu = !this.showStatusMenu;
        $event.stopPropagation();
    }

    executeInlineCompFn($event: MouseEvent, opt: TCITenantAppDetailsMenu) {
        const selector = opt.getComponentSelectorType();
        const selStr = selector.toString();
        const tenantHMInput = new BaseAppDetailMenuComponentInput(
            this.app.type,
            selector,
            this.app,
            this.userService,
            this.featureToggleService,
            TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_MENU,
            opt,
            this.submenuLeftRouteId
        );
        const injector = this.tenantMenuSrv.getTenantInjector(this.app.type);
        this.statusMenuOptionsInlineFns[selStr](opt, tenantHMInput, injector).subscribe();
        this.toggleStatusMenu($event);
    }

    /**
     * </Hamburger Menu Status>
     *
     * <Hamburger Menu modal handling>
     */
    mountStatusMenuComponent() {
        if (this.statusMenuOptions.map(sm => sm.getRouteId()).includes(this.routeId)) {
            const statusMenuOption = this.statusMenuOptions.find(opt => opt.getRouteId() === this.routeId);
            this.statusMenuCmpInput = new BaseAppDetailMenuComponentInput(
                this.app.type,
                statusMenuOption.getComponentSelectorType(),
                this.app,
                this.userService,
                this.featureToggleService,
                TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HAMBURGER_MENU,
                undefined,
                null);
            this.statusMenuSelectedOption = statusMenuOption;
        } else {
            this.statusMenuCmpInput = undefined;
            this.statusMenuSelectedOption = undefined;
        }
    }

    statusMenuCmpClose() {
        if (!lodash.isUndefined(this.tabFixedRoute)) {
            this.navigateComponents(this.tabFixedRoute);
        } else {
            this.location.back();
        }
    }

    evaluateStatusMenuOutput($event: ITCIAppDetailsMenuOutput) {
        // console.log("Evaluation HMenu Output", $event);

        if ($event.menuItemSelector) {
            // Evaluate HM output to manipulate local app data
            switch ($event.menuItemSelector.toString()) {
                /**
                 * In these cases the transfer of ownership might affect
                 * the tags mode and header components
                 */
                case TCITenantSelectorType.TCI_APP_DETAIL_TRANSFER_OWNERSHIP.toString():
                case TCITenantSelectorType.TCI_APP_DETAIL_REPLACE_APPLICATION.toString():
                    if ($event.refresh) { // Update owner name
                        this.appsAPISrv.getAppById(this.appId, this.app.type)
                            .subscribe(data => {
                                this.app.owner = data.owner;
                                this.app.ownerName = data.ownerName;
                                this.afterHMOutput();
                            });
                    }
                    break;
            }

            // Evaluate the HM output to refresh app data
            // All the notification would result in evaluation of refresh
            this.appRefreshNotifSvc.evaluateHMOutput(this.app, $event);
        }
        this.statusMenuCmpClose();
    }

    // IPAS-15724 - Evaluate components Input after ChangeOwner or AppReplace
    private afterHMOutput() {
        // RO
        this.hmSvc.checkIsRO(this.app)
            .subscribe(isRO => this.isRO = isRO);

        // Tags
        delete this.tagsMode;
        this.setTagsMode();

        // Header Components
        this.mountHeaderComponents()
            .canUpdate();
    }

    // IPAS-15022 - Update the pills after deployment change
    // Retreive app.info and set it so further checks will be updated
    // Do this only if state is different
    checkPillsAfterDeployment() {
        if (this.tabs.length === 0) { // Components are not ready
            return;
        }

        const label = this.appDeplSvc.getLastState(this.app.id).label;
        if ((lodash.isUndefined(this.lastDeploymentState) || !lodash.isEqual(this.lastDeploymentState, label))) {
            this.lastDeploymentState = label;
            this.appsAPISrv
                .getAppById(this.appId, TCITenantAppType.fromString(this.app.type.toString()))
                .subscribe(appData => {
                    this.app.info = appData.info;
                    this.mountHeaderComponents();
                });
        }
    }

    /**
     * </Hamburger Menu modal handling>
     *
     * <Name & Description>
     */
    getUpdateInput(actionType: TCI_UPDATE_ACTION_TYPE): ITCIApplicationUpdateRequest {
        return {
            actionType,
            appId: this.appId,
            application: this.app,
            tenantType: this.app.type
        };
    }

    identifyTenantProvider() {
        this.tenantSvc.onInit()
            .switchMap(() => this.tenantRemoteServices.getRemoteServices())
            .map(services => services.map(s => TCITenantAppType.fromString(s.name).toString()))
            .subscribe(services => {
                if (!services.includes(this.app.type.toString())) {
                    this.toastrSvc.info(lodash.capitalize(this.app.type.toString()) + " is not available at this moment");
                    this.goBack();
                    return;
                }

                const tenant = this.tenantModelSvc.getTenant(this.app.type);
                const updateProvider = tenant.getAppUpdateProvider();
                if (updateProvider) {
                    this.appUpdateProvider = updateProvider;
                    this.canUpdate();
                } else {
                    console.warn("No AppUpdate service provider available");
                }
            });
        return this;
    }

    private stopAppUpdate() {
        this.subsCollection.push(
            this.appUpdateProvider.stopUpdateSubscription(this.app)
                .filter(res => !!res)
                .subscribe(() => this.saveSelectedTags())
        );
    }

    updateChanged($event: string, isName = true) {
        if (isName) {
            this.appUpdateProvider.setDirty($event !== this.originalAppName, TCI_UPDATE_ACTION_TYPE.APP_NAME);
        } else {
            this.appDescription = $event;
            this.appUpdateProvider.setDirty($event !== this.originalAppDescription, TCI_UPDATE_ACTION_TYPE.APP_DESCRIPTION);
        }
    }

    updateStart(isName = true) {
        const action = isName ? TCI_UPDATE_ACTION_TYPE.APP_NAME : TCI_UPDATE_ACTION_TYPE.APP_DESCRIPTION;
        const content = document.getElementsByClassName("plaintext");
        for (let i = 0; i < content.length; i++) {
            // removing the pre-registered event handlers on this target
            content[i].removeEventListener("paste", this.pasteEventHandler);
            content[i].addEventListener("paste", this.pasteEventHandler);
        }
        this.subsCollection.push(
            this.appUpdateProvider.startUpdateSubscription(this.app).subscribe(),
            this.appUpdateProvider.isBusy(this.getUpdateInput(action))
                .subscribe(res => this.appUpdateIsBusy = res)
        );
        if (!isName && (this.appDescription || "").trim() === "Application description") {
            this.appDescription = "";
        }
    }

    updateStartForTags() {
        const action = TCI_UPDATE_ACTION_TYPE.UPDATE_TAGS;

        this.subsCollection.push(
            this
                .appUpdateProvider
                .startUpdateSubscription(this.app)
                .subscribe(),
            this
                .appUpdateProvider
                .isBusy(this.getUpdateInput(action))
                .subscribe(res => this.appUpdateIsBusy = res)
        );
    }

    pasteEventHandler(event) {
        event.preventDefault();
        if (event["clipboardData"] && event["clipboardData"].getData) {
            const text = event["clipboardData"].getData("text/plain");
            document.execCommand("insertHTML", false, text);
        }
    }

    canUpdate() { // Check the permission to update name and description
        if (!this.componentIsAlive) {
            return;
        }

        this.subsCollection.push(
            this.appUpdateProvider
                .canUpdateApplication(this.getUpdateInput(TCI_UPDATE_ACTION_TYPE.APP_NAME))
                .subscribe(res => this.canUpdateName = res),

            this.appUpdateProvider
                .canUpdateApplication(this.getUpdateInput(TCI_UPDATE_ACTION_TYPE.APP_DESCRIPTION))
                .subscribe(res => this.canUpdateDescription = res)

            // TODO: Add the TAGS evaluation in here
        );
    }

    restoreName() {
        this.app.name = this.originalAppName;
        this.updateChanged(this.originalAppName);
        this.stopAppUpdate();
    }

    updateName() {
        if (!this.isNameUpdating) {
            delete this.appNameUpdateErrorMsg;
            if (this.originalAppName !== this.app.name) {
                this.isNameUpdating = true;
                const input = this.getUpdateInput(TCI_UPDATE_ACTION_TYPE.APP_NAME);
                input.newApplicationName = this.app.name;
                this.appUpdateProvider.updateApplication(input)
                    .finally(() => {
                        this.isNameUpdating = false;
                        this.canUpdate();
                        this.stopAppUpdate();
                    })
                    .subscribe(
                        res => {
                            if (res.success) {
                                this.originalAppName = res.name;
                                this.requestRefreshApp();
                            } else {
                                this.appNameUpdateErrorMsg = res.msg;
                            }
                        },
                        err => {
                            this.appNameUpdateErrorMsg = err.msg;
                            this.restoreName();
                            console.error("App was not renamed", err);
                        }
                    );
                this.canUpdate();
            } else {
                this.stopAppUpdate();
            }
        } else {
            this.stopAppUpdate();
        }
    }

    restoreDescription() {
        this.app.description = this.originalAppDescription;
        this.updateChanged(this.originalAppDescription, false);
        this.stopAppUpdate();
    }

    updateDescription() {
        if (!this.isDescriptionUpdating) {
            delete this.appDescriptionUpdateErrorMsg;
            if (this.originalAppDescription !== this.app.description) {
                this.isDescriptionUpdating = true;
                const input = this.getUpdateInput(TCI_UPDATE_ACTION_TYPE.APP_DESCRIPTION);
                input.newApplicationDescription = this.app.description;
                this.appUpdateProvider.updateApplication(input)
                    .finally(() => {
                        this.isDescriptionUpdating = false;
                        this.canUpdate();
                    })
                    .subscribe(
                        res => {
                            if (res.success) {
                                this.originalAppDescription = this.app.description;
                                this.requestRefreshApp();
                            } else {
                                this.appDescriptionUpdateErrorMsg = res.msg;
                            }
                        },
                        err => {
                            this.appDescriptionUpdateErrorMsg = err.msg;
                            this.restoreDescription();
                            console.error("App description was not updated", err);
                        });
                this.canUpdate();
            }
        }
    }

    requestRefreshApp() {
        if (!this.appDescriptionUpdateErrorMsg && !this.appNameUpdateErrorMsg) {
            this.appRefreshNotifSvc.requestRefresh(this.app, undefined, TCI_TENANT_SERVICE_PROVIDER_TYPE.APP_UPDATE);
        }
    }

    /**
     * The following solution was made to avoid "null" value to be placed
     * at the contenteditable element, which was giving problems for Flogo
     * https://tibco.slack.com/archives/GQ5TDJGF3/p1576696336003000
     */
    get appDescription(): string {
        const desc = this.app.description || "";
        if (this.appDescriptionPristine && !this.app.onPremise) {
            return (lodash.isEmpty(desc.trim())) ? "Application description" : desc;
        } else {
            return desc;
        }
    }

    set appDescription(value: string) {
        if (lodash.isString(value)) { // Double check!
            this.appDescriptionPristine = false;
            this.app.description = value;
        }
    }

    // IPAS-12322
    tabNoDoubleClick(tab: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>) {
        this.tabBusy = tab.getRouteId() !== this.selectedTab.getRouteId();
    }

    // Customizer
    private getCustomConfig() {
        const appDetailCustomTypes = [
            this.CUSTOM_TYPES.APP_LIST_COL_DEPLOYMENT,
            this.CUSTOM_TYPES.APP_LIST_COL_STATUS,
            this.CUSTOM_TYPES.APP_DETAIL_HEADER_CATEGORY,
            this.CUSTOM_TYPES.APP_DETAIL_HEADER_TAGS
        ];
        const customConfigObs: Observable<ITCIAppCustomizationParam>[] = appDetailCustomTypes.map(customType => {
            // Prepare observables to get the config of each type
            return this
                .customizationProviderService
                .getCustomizations({
                    type: customType
                })
                .map(custom => custom.success ? custom.result : null)
                .map((customParam: ITCIAppCustomizationParam) => {
                    if (customParam) {
                        this.customConfig[customType] = customParam;
                    }
                    return customParam;
                });
        });

        // Request the custom configuration
        Observable.merge(...customConfigObs)
            .take(appDetailCustomTypes.length)
            .toArray()
            .subscribe(() => {
                if (this.getCustomVisible(this.CUSTOM_TYPES.APP_DETAIL_HEADER_TAGS)) {
                    this.initTags();
                }
            });
    }

    private initTags(refreshApp = false) {
        if (this.app) {
            this.subsCollection.push(
                this.tagsService.getAllTags()
                    .subscribe((tagsList: ITCIAssetTagsList) => {
                        this.tagsList = tagsList;
                        this.allAssetTags = lodash.map(
                            lodash.keys(this.tagsService.simplifyTagsList(this.tagsList)),
                            tagId => ({name: tagId})
                        );

                        this.populateTagsData(refreshApp);
                        this.hasTagsList = true;
                        this.tagsPillVisible = true;
                    })
            );
        }
    }

    private getCustomVisible(type: TCI_APP_CUSTOMIZATION_TYPE): boolean {
        const custom = this.customConfig[type];
        if (!custom) {
            return false;
        }
        return this.customConfig[type].enabled && this.customConfig[type].visible;
    }

    storeSelectedTags(selectedTags: ITCIAssetTag[]) {
        if (this.hasTagsList) { // Ensure that the tags are bound to the app
            this.deltaSelectedTags = lodash.cloneDeep(selectedTags);
            this.tagsIsDirty = true;

            const leftPart = this.pristineSelectedTags.map(t => t.name).sort().join();
            const rightPart = this.deltaSelectedTags.map(t => t.name).sort().join();
            this.appUpdateIsBusy = leftPart !== rightPart;
        } else {
            console.error("The tags are not bound to the app yet");
        }
    }

    private saveSelectedTags(): void {
        // Check if the tags have been mapped to the app and update is busy
        if (this.tagsIsDirty && this.appUpdateIsBusy) {
            this.selectedTags = this.deltaSelectedTags;
            this.tagsUpdateIsBusy = true;
            this.app.tagsAdded = lodash.map(
                lodash.differenceWith(
                    this.simplifyTags(this.selectedTags),
                    this.simplifyTags(this.pristineSelectedTags),
                    lodash.isEqual
                ),
                tag => ({name: tag.name})
            );

            this.app.tagsRemoved = lodash.map(
                lodash.differenceWith(
                    this.simplifyTags(this.pristineSelectedTags),
                    this.simplifyTags(this.selectedTags),
                    lodash.isEqual
                ),
                tag => ({name: tag.name})
            );

            const reset = () => {
                this.canUpdate();
                this.tagsIsDirty = false;
                this.appUpdateIsBusy = false;
                this.tagsUpdateIsBusy = false;
            };

            // Send backend request for update tags only if something changed.
            this.appsAPISrv
                .saveTags(this.appUpdateProvider, this.getUpdateInput(TCI_UPDATE_ACTION_TYPE.UPDATE_TAGS))
                .subscribe(
                    response => {
                        if (response.success) {
                            this.toastrSvc.success("Tags saved");
                        } else {
                            this.toastrSvc.error(`Failed to save tags. ${response.msg ? response.msg : ""}`);
                        }

                        this.initTags(true);
                        reset();
                    },
                    () => {
                        this.toastrSvc.error("Error occurred while saving tags.");
                        this.initTags(true);
                        reset();
                    }
                );
        }
    }

    simplifyTags(tags: ITCIAssetTag[]): ITCIAssetTag[] {
        return lodash.map(tags, (tag: ITCIAssetTag) => ({name: tag.name}));
    }

    private populateTagsData(refreshApp = false) {
        this.tagsService.populateTagsToAssets([this.app], this.tagsList);
        this.selectedTags = lodash.cloneDeep(this.app.tags);
        this.pristineSelectedTags = lodash.cloneDeep(this.app.tags);
        if (refreshApp) {
            this.appRefreshNotifSvc.requestRefresh(this.app);
        }
    }

    setTagsMode(): void {
        if (this.app && !this.tagsMode) {
            const checkIsRo = () => { // Do a regular RO evaluation
                this.hmSvc.checkIsRO(this.app)
                    .subscribe(isRO => {
                        this.tagsMode = isRO ?
                            TCI_ASSET_TAGS_COMPONENT_MODE.SELECT_ONLY :
                            TCI_ASSET_TAGS_COMPONENT_MODE.FULLY_FUNCTIONAL;
                    });
            };

            // IPAS-16020 - OnPremise apps allow tags for USR users
            // IPAS-16109 - Scribe apps allow tags for USR users
            if (this.app.type.equals(TCITenantAppType.scribe) || this.app.onPremise) {
                this.userService.getAuthForFunction(APPLICATION_SCOPE_TYPES.APP)
                    .subscribe(usrData => {
                        if (usrData.role === USER_ROLES.USR) { // It's USR: Let it have tags
                            this.tagsMode = TCI_ASSET_TAGS_COMPONENT_MODE.FULLY_FUNCTIONAL;
                        } else {
                            checkIsRo();
                        }
                    });
            } else {
                checkIsRo();
            }
        }
    }
}
